<template>
   <div>
      <div class="row">
         <div class="col-md-12 col-lg-12 col-xl-12">
            <div class="text-center mt-1 mb-2">
            </div>
         </div>
      </div>

      <!-- LIST VIEW -->
      <div class="row" v-if="onListView">
         <div class="col-12">
            <div class="card m-b-30">
               <div class="card-header pt-4 px-4">
                  <h3 class="card-title font-18">Lista de promociones disponibles</h3>
               </div>
               <div class="card-body px-4">
                  <div class="row">
                     <purchase-promotion-card v-for="(promo, index) in applicablePromotions" :key="index" :promotion="promo"  @on-cart-action="onPromoCartAction" />
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- FIN LIST VIEW -->

      <!-- PURCHASE VIEW -->
      <div v-if="onPurchaseView">
         <div class="card">
            <div class="card-body py-4 px-4">
               <div class="row align-items-center mt-3">
                   <div class="col-12 text-left">
                     <h4 class="card-title font-18">{{currentProductName}}</h4>
                     <!--h4 class="mb-1">{{currentPriceFormat}}</h4-->
                     <span class="badge mt-1 font-14" :class="badgeClass">{{currentStock}} aplicables</span>
                  </div>
                  <div class="col-12 pl-3 pt-3">
                     <h4 class="font-15">{{currentDescription}}</h4>
                  </div>
               </div>

               <hr class="my-3">

               <!-- WIZARD -->
               <div class="row justify-content-center">
                  <div class="col-12">
                     <div class="basic-form-wizard">
                        <div role="application" class="wizard clearfix">
                           <div class="steps clearfix">
                              <div class="form-wizard-line"></div>
                              <ul role="tablist">
                                 <li v-for="step in configSteps" :key="step.number" role="tab" :class="getWizardStepClass(step.number)">
                                    <a>
                                       <span class="number">{{step.number}}</span>
                                       <span class="step-title">{{step.title}}</span>
                                    </a>
                                 </li>
                              </ul>
                           </div>
                        </div>
                     </div>
                  </div>   
               </div>
               <!-- FIN WIZARD -->

               <hr class="my-3">

               <div class="row" v-if="errorMssg">
                  <div class="col-12 text-left mb-2">
                     <div class="text-error">{{errorMssg}}</div>
                  </div>
               </div>

               <!-- QUANTITY SUBVIEW -->
               <template v-if="onPurchaseQuantitySubview">
                  <div class="row align-items-center mt-2" >
                     <div class="col-lg-3 col-4 text-left">
                        <span class="font-15">¿Cuántas promociones quieres agregar?</span>
                     </div>
                     <div class="col-lg-3 col-4 text-left">
                        <input type="number" class="form-control form-control-high" name="inputPieces" id="inputPieces" min="1" v-model="promoQuantity">
                     </div>
                  </div>
                  <hr class="my-3">
                  <promo-action-btn text="Confirmar cantidad" @on-action="onStepConfirmed" />
                  <hr class="mt-3 mb-2">
                  <promo-cancel-btn @on-action="onStepCancel" />
               </template>
               <!-- END QUANTITY SUBVIEW -->

               <!-- SHOW QUANTITY -->
               <template v-if="canShowQuantity">
                  <h5 class="mb-3">Cantidad de promociones elegida: {{promoQuantity}}</h5>
                  <hr class="my-3">
               </template>
               <!-- END SHOW QUANTITY -->

               <!-- SET PRODS SUBVIEW -->
               <template v-if="onPurchaseSetProductsSubview">
                  <h5>Seleccione los productos para generar su promoción</h5>
                  <h6>De click en el botón "Agregar producto" y seleccione el producto y cantidad.</h6>

                  <promo-products-select
                     key="prodsConfig"
                     ref="productsConfig"
                     :promotion="currentPromotion"
                     :selectionableProducts="selectionableProducts"
                     :promoQuantity="promoQuantity"
                     :totalRequired="totalProductsRequired"
                     :prechargedProducts="selectedProducts"
                     @on-selection-changed="onProdsConfigChanged" />

                  <div v-if="productsSelectionCompleted">
                     <hr class="my-3">
                     <promo-action-btn text="Confirmar productos" @on-action="onStepConfirmed" />
                  </div>

                  <hr class="mt-3 mb-2">
                  <promo-cancel-btn text="Atrás" @on-action="onStepBack" />
                  <hr class="my-2">
                  <promo-cancel-btn @on-action="onStepCancel" />
               </template>
               <!-- END SET PRODS SUBVIEW -->

               <!-- SET GIFTS SUBVIEW -->
               <template v-if="onPurchaseSetGiftsSubview">
                  <h5>Seleccione los regalos que desee en su promoción</h5>
                  <h6>De click en el botón "Agregar regalo" y seleccione el producto y cantidad.</h6>

                  <promo-products-select
                     ref="giftsConfig"
                     key="giftsConfig"
                     :promotion="currentPromotion"
                     :selectionableProducts="selectionableGifts"
                     :promoQuantity="promoQuantity"
                     :totalRequired="totalGiftsRequired"
                     :prechargedProducts="selectedGifts"
                     :forGifts="true"
                     @on-selection-changed="onGiftsConfigChanged" />

                  <div v-if="giftsSelectionCompleted">
                     <hr class="my-3">
                     <promo-action-btn text="Confirmar regalos" @on-action="onStepConfirmed" />
                  </div>

                  <hr class="mt-3 mb-2">
                  <promo-cancel-btn text="Atrás" @on-action="onStepBack" />
                  <hr class="my-2">
                  <promo-cancel-btn @on-action="onStepCancel" />
               </template>
               <!-- END SET GIFTS SUBVIEW -->

               <!-- CONFIG CONFIRMATION SUBVIEW -->
               <template v-if="onPurchaseConfigConfirmationSubview">
                  <h6>Confirme las selecciones de sus productos</h6>
                  <promo-products-resume
                     :selectedProducts="selectedProducts"
                     :selectedGifts="selectedGifts"
                     :totalDiscount="totalDiscount"
                  />
                  
                  <hr class="my-3">
                  <promo-action-btn btnClass="success" text="Confirmar y agregar promoción" @on-action="onStepConfirmed" />

                  <hr class="my-2">
                  <promo-cancel-btn text="Atrás" @on-action="onStepBack" />
                  <hr class="my-2">
                  <promo-cancel-btn @on-action="onStepCancel" />
               </template>
               <!-- END CONFIG CONFIRMATION SUBVIEW -->

               <!-- NON-CONFIG CONFIRMATION SUBVIEW -->
               <template v-if="onPurchaseNonConfigConfirmationSubview">
                  <h6>Verifique el contenido de la promoción</h6>
                  <promo-products-resume
                     :selectedProducts="selectedProducts"
                     :selectedGifts="selectedGifts"
                     :totalDiscount="totalDiscount"
                  />
                  
                  <hr class="my-3">
                  <promo-action-btn btnClass="success" text="Confirmar y agregar promoción" @on-action="onStepConfirmed" />

                  <hr class="my-2">
                  <promo-cancel-btn text="Atrás" @on-action="onStepBack" />
                  <hr class="my-2">
                  <promo-cancel-btn @on-action="onStepCancel" />
               </template>
               <!-- END NON-CONFIG CONFIRMATION SUBVIEW -->

            </div>
         </div>
      </div>
      <!-- FIN PURCHASE VIEW -->

   </div>
</template>

<script>
import PurchasePromotionCard from "@components/clients/PurchasePromotionCard.vue"
import {Promotion} from "../../classes/promotion"
import {SimpleProduct} from "../../classes/simple_product"
import promotionsHelper from "@mixins/promotionsHelper"
import {TipoBeneficio, MecanicaPromocion, TipoProductoParticipante} from "../../classes/enums"
import cartHelper from "@mixins/cartHelper"
import {mapMutations, mapGetters, mapState} from "vuex";
import PromoActionBtn from '../../components/clients/PromoActionBtn.vue'
import PromoCancelBtn from '../../components/clients/PromoCancelBtn.vue'
import PromoProductsSelect from '../../components/clients/PromoProductsSelect.vue'
import PromoProductsResume from '../../components/clients/PromoProductsResume.vue'
export default {
   data(){
      return {
         promotions: [],
         products: [],
         applicablePromotions: [],

         activePrompt: false,
         currentPromotionId: null,
         currentPromotion: null,

         promoQuantity: 1,
         prevPromoQuantity: -1,
         currentAmount: 0,
         isOnEdit: false,
         onSettings: false,
         onFinished: false,

         currentProdPieces: 0,
         selectedProducts: [],
         selectedGifts: [],

         currentProdDemoId: null,

         onProdSelect: false,
         onGiftSelect: false,

         currentGiftsNeeded: 0,
         currentProductsNeeded: 0,

         errorMssg: null,

         currentView: 0,
         currentPurchaseSubview: 0,

         thumbnailUrl: "https://i.ibb.co/TcVZypR/mini-product.png",

         configSteps: [],
         currentStepIndex: null,
         currentStep: null,

         selectionableProducts: [],
         totalProductsRequired: 0,
         productsSelectionCompleted: false,

         selectionableGifts: [],
         totalGiftsRequired: 0,
         giftsSelectionCompleted: false,

         totalDiscount: 0,
      }
   },
   components: {
      PurchasePromotionCard,
      PromoActionBtn,
      PromoCancelBtn,
      PromoProductsSelect,
      PromoProductsResume
   },
   mixins: [promotionsHelper, cartHelper],
   async mounted(){
      await this.loadPromotions()
   },
   created() {
      // constantes
      this.LIST_VIEW = 0
      this.PURCHASE_VIEW = 1

      this.PURCHASE_QUANTITY_SUBVIEW = 0
      this.PURCHASE_SET_PRODUCTS_SUBVIEW = 1
      this.PURCHASE_SET_GIFTS_SUBVIEW = 2
      this.PURCHASE_CONFIG_CONFIRMATION_SUBVIEW = 3
      this.PURCHASE_NON_CONFIG_CONFIRMATION_SUBVIEW = 4

      this.ERROR_NOT_VALID_QUANTITY = "Por favor defina una cantidad válida."
      this.ERROR_STOCK_OVERFLOW = "No es posible agregar más elementos de los que hay disponibles."
      
   },
   methods: {
      ...mapMutations("cart", ["addPromotionDetail", "updatePromoAmounts"]),
      async loadPromotions(){
         this.showLoader("Obteniendo promociones...")
         const res = await this.xget('/promociones_para_venta');
         if(res.success){
            this.setPromotions(res.data.promociones)
            this.setProducts(res.data.stock)
            this.applicablePromotions = this.filterPromotionsForProducts(this.promotions, this.products);
         }
         this.stopLoader()
      },
      setPromotions(rawPromotions){
         this.promotions = [];
         rawPromotions.forEach(promo => {
            this.promotions.push(Promotion.fromServicePromotion(promo));
         });
      },
      setProducts(rawProducts){
         this.products = [];
         rawProducts.forEach(prod => {
            this.products.push(SimpleProduct.fromServiceSimpleProduct(prod));
         });
      },

      updateProductUI(){
         if(!this.currentPromotion){
            return
         }
         this.currentAmount = 0// this.currentProduct.cost * this.promoQuantity;
         this.formattedAmount = 0// this.fixedFormat(this.currentAmount, 2)
      },

      async onPromoCartAction(id){
         this.selectedProducts = []
         this.selectedGifts = []
         this.currentProdPieces = 1
         // verificar si el producto ya ha sido cargado
         this.promoQuantity = 1// (existing ? parseInt(existing.pieces) : 1)
         this.prevPromoQuantity = -1
         this.isOnEdit = false// (existing != null)
         this.currentPromotionId = id
         this.currentPromotion = this.applicablePromotions.find(f => f.id === id)
         this.updateProductUI()
         this.onSettings = false
         this.onFinished = false

         // establecer los pasos que correspondan para el flujo de config.
         this.setConfigSteps()
         this.startSteps()
      },
      resetError(){
         this.errorMssg = null
      },

      setConfigSteps(){
         this.configSteps = []
         let counter = 1;

         // paso <seleccion de cantidad>
         this.configSteps.push({ number: counter, title: "Definir cantidad", name: "setQuantity", reverse: "onBackToQuantity",
            init: "onQuantityInit", confirmed: "onQuantityStepConfirmed", back: "onQuantityCancel", cancel: "onQuantityCancel" })


         // si la promo requiere config.
         if(this.currentPromoIsConfigurable){
            // config. de productos
            if(this.currentPromoSetsProducts){
               counter += 1;
               this.configSteps.push({ number: counter, title: "Selección de productos", name: "setProducts", reverse: null,
                  init: "onProdsConfigInit", confirmed: "onProdsConfigStepConfirmed", back: "onProdsConfigBack", cancel: "onProdsConfigCancel" })
            }

            // config. de regalos
            if(this.currentPromoSetsGifts){
               counter += 1;
               this.configSteps.push({ name: "setGifts", number: counter, title: "Selección de regalos", reverse: null,
                  init: "onGiftsConfigInit", confirmed: "onGiftsConfigStepConfirmed", back: "onGiftsConfigBack", cancel: "onGiftsConfigCancel" })
            }

            // confirmacion de config
            counter += 1;
            this.configSteps.push({ name: "confirmConfig", number: counter, title: "Confirmación", reverse: null,
               init: "onConfigConfirmInit", confirmed: "onConfigConfirmStepConfirmed", back: "onConfigConfirmBack", cancel: "onConfigConfirmCancel" })
         }
         else {
            // confirmacion de promo sin config
            counter += 1;
            this.configSteps.push({ name: "confirmNonConfig",number: counter, title: "Confirmación", reverse: null,
               init: "onNonConfigConfirmInit", confirmed: "onNonConfigConfirmStepConfirmed", back: "onNonConfigConfirmBack", cancel: "onNonConfigConfirmCancel" })
         }
      },
      // VALIDATION STEPS

      async startSteps() {
         this.currentStepIndex = 0
         this.currentStep = this.configSteps[0]
         const action = this.currentStep.init
         await this[action]()
      },
      async nextStep() {
         this.currentStepIndex += 1
         this.currentStep = this.configSteps[this.currentStepIndex]
         const action = this.currentStep.init
         await this[action]()
      },
      async prevStep() {
         this.currentStepIndex -= 1
         this.currentStep = this.configSteps[this.currentStepIndex]
         const reverse = this.currentStep.reverse
         if(reverse){
            await this[reverse]()
         }
         const action = this.currentStep.init
         await this[action]()
      },
      async onStepConfirmed() {
         const action = this.currentStep.confirmed
         await this[action]()
      },
      async onStepBack() {
         const action = this.currentStep.back
         await this[action]()
      },
      async onStepCancel() {
         const action = this.currentStep.cancel
         await this[action]()
      },

      //****** QUANTITY ***** //
      async onQuantityInit() {
         this.resetError()
         this.currentPurchaseSubview = this.PURCHASE_QUANTITY_SUBVIEW
         this.currentView = this.PURCHASE_VIEW
      },
      async onBackToQuantity(){
      },
      async onQuantityStepConfirmed(){
         // validar la cantidad
         if(!this.validateQuantity()){
            return
         }
         // preguntar si desea cambiar la cantidad
         if((this.currentPromoIsConfigurable) && (this.prevPromoQuantity !== -1) && (this.promoQuantity != this.prevPromoQuantity)){
            const mssg = "Al modificar la cantidad, la configuración de los productos o regalos tendrá que ser " +
            "realizada de nuevo."
            this.confirmationDialog(this.doConfirmQuantityChange, "Modificar cantidad", mssg, "Confirmar")
         }
         else {
            this.prevPromoQuantity = this.promoQuantity
            await this.nextStep()
         }
      },
      async doConfirmQuantityChange(){
         this.prevPromoQuantity = this.promoQuantity
         this.selectedProducts = []
         this.selectedGifts = []
         await this.nextStep()
      },
      async onQuantityCancel(){
         this.backToListView()
      },
      validateQuantity(){
         if(this.promoQuantity < 1) {
            this.errorMssg = this.ERROR_NOT_VALID_QUANTITY
            return false
         }
         if(this.promoQuantity > this.currentStock){
            this.errorMssg = this.ERROR_STOCK_OVERFLOW
            return false
         }
         this.errorMssg = null
         return true
      },
      //****** END QUANTITY ***** //

      //****** SET PRODS ***** //
      async onProdsConfigInit() {
         this.productsSelectionCompleted = false
         this.totalProductsRequired = this.calculateTotalProductsRequired()
         this.selectionableProducts = this.getSelectionableProductsForPromo(this.currentPromotion, this.products)
         this.currentPurchaseSubview = this.PURCHASE_SET_PRODUCTS_SUBVIEW
      },
      async onProdsConfigStepConfirmed(){
         // obtener los productos seleccionados desde el componente
         this.selectedProducts = this.$refs.productsConfig.getSelectedProducts()
         await this.nextStep()
      },
      async onProdsConfigBack(){
         // guardar el "borrador" de los productos configurados
         this.selectedProducts = this.$refs.productsConfig.getSelectedProducts()
         await this.prevStep()
      },
       async onProdsConfigCancel(){
         this.askForCancelPromo()
      },
      async onProdsConfigChanged(completed){
         this.productsSelectionCompleted = completed
      },
      //****** END SET PRODS ***** //

      //****** SET GIFTS ***** //
      async onGiftsConfigInit() {
         this.giftsSelectionCompleted = false
         this.totalGiftsRequired = this.calculateTotalGiftsRequired()
         this.selectionableGifts = this.getSelectionableGiftsForPromo(this.currentPromotion, this.products)
         this.currentPurchaseSubview = this.PURCHASE_SET_GIFTS_SUBVIEW
      },
      async onGiftsConfigStepConfirmed(){
         // obtener los regalos seleccionados desde el componente
         this.selectedGifts = this.$refs.giftsConfig.getSelectedProducts()
         await this.nextStep()
      },
       async onGiftsConfigBack(){
         // guardar el "borrador" de regalos configurados
         this.selectedGifts = this.$refs.giftsConfig.getSelectedProducts()
         await this.prevStep()
      },
      async onGiftsConfigCancel(){
         this.askForCancelPromo()
      },
      async onGiftsConfigChanged(completed){
         this.giftsSelectionCompleted = completed
      },
      //****** END SET GIFTS ***** //

      //****** CONFIG CONFIRMATION ***** //
      async onConfigConfirmInit() {
         // establecer automaticamente los productos/regalos que no sean configurables

         // verificar si se deben seleccionar automaticamente los productos
         if(!this.currentPromoSetsProducts){
            const autoProd = this.autoSelectProducts()
            this.selectedProducts = [autoProd]
         }

         // revisar si la promo ofrece regalos y deben configurarse automaticamente
         if(this.currentPromoHasGifts && !this.currentPromoSetsGifts){
            const autoGift = this.autoSelectGifts()
            this.selectedGifts = [autoGift]
         }

         // calculo de descuento en caso de aplicar
         if(this.currentPromoOffersDiscount){
            this.totalDiscount = this.calculateTotalDiscount()
         }

         this.currentPurchaseSubview = this.PURCHASE_CONFIG_CONFIRMATION_SUBVIEW
      },
      async onConfigConfirmStepConfirmed(){
         // guardar los elementos al state
         await this.saveConfigToState()

         // salir
         this.backToListView()   
      },
      async onConfigConfirmBack(){
         await this.prevStep()
      },
      async onConfigConfirmCancel(){
         this.askForCancelPromo()
      },
      //****** END CONFIG CONFIRMATION ***** //

      //****** NON-CONFIG CONFIRMATION ***** //
      async onNonConfigConfirmInit() {
         // establecer los productos/regalos automaticamente

         // productos (siempre se seleccionan al menos los productos)
         const autoProd = this.autoSelectProducts()
         this.selectedProducts = [autoProd]

         // revisar si la promo ofrece regalos y deben condigurarse automaticamente
         if(this.currentPromoHasGifts && !this.currentPromoSetsGifts){
            const autoGift = this.autoSelectGifts()
            this.selectedGifts = [autoGift]
         }

         // calculo de descuento en caso de aplicar
         if(this.currentPromoOffersDiscount){
            this.totalDiscount = this.calculateTotalDiscount()
         }

         this.currentPurchaseSubview = this.PURCHASE_NON_CONFIG_CONFIRMATION_SUBVIEW
      },
      async onNonConfigConfirmStepConfirmed(){
         // guardar los elementos al state
         await this.saveConfigToState()

         // salir
         this.backToListView()
      },
      async onNonConfigConfirmBack(){
         await this.prevStep()
      },
      async onNonConfigConfirmCancel(){
         this.askForCancelPromo()

         // salir
         this.backToListView()
      },
      //****** END NON-CONFIG CONFIRMATION ***** //

      async saveConfigToState(){
         // generar los detalles de orden para los productos
         let orderDetails = []
         let promoTotal = 0
         let promoDiscount = this.totalDiscount
         
         this.selectedProducts.forEach(f => {
            promoTotal += f.total
            const detail = this.getOrderDetailForProductId(f.id, f.pieces, false)
            orderDetails.push(detail)
         })
         this.selectedGifts.forEach(f => {
            const detail = this.getOrderDetailForProductId(f.id, f.pieces, true)
            orderDetails.push(detail)
         })

         // generar el detalle y guardarlo en el state
         const intQuantity = parseInt(this.promoQuantity)
         const promoTotalDiscounted = promoTotal - promoDiscount
         const promoDetail = this.setPromotionDetail(this.currentPromotion, intQuantity, orderDetails, promoTotal, promoDiscount, promoTotalDiscounted)
         this.addPromotionDetail(promoDetail)

         // calculate amounts
         const amounts = this.calculateTotalPromoAmounts(this.promotion_details)
         this.updatePromoAmounts(amounts);
      },

      getOrderDetailForProductId(id, quantity, isGift) {
         const originalProd = this.products.find(f => f.id === id)
         if(isGift){
            return this.setGiftOrderDetail(originalProd, quantity)
         }
         else {
            return this.setOrderDetail(originalProd, quantity)
         }
      },
    
      calculateTotalProductsRequired() {
         return parseInt(this.currentPromotion.mechanic.quantity) * parseInt(this.promoQuantity)
      },
      calculateTotalGiftsRequired() {
         return parseInt(this.currentPromotion.benefit.quantity) * parseInt(this.promoQuantity)
      },
      calculateTotalDiscount() {
         return parseFloat(this.currentPromotion.benefit.price) * parseInt(this.promoQuantity)
      },
      autoSelectProducts(){
         const piecesRequired = this.calculateTotalProductsRequired()
         const prods = this.getSelectionableProductsForPromo(this.currentPromotion, this.products)
         const prod = prods[0]
         const total = prod.cost * piecesRequired
         return {id: prod.id, name: prod.name, pieces: piecesRequired, total: total}
      },
      autoSelectGifts(){
         const piecesRequired = this.calculateTotalGiftsRequired()
         const gifts = this.getSelectionableGiftsForPromo(this.currentPromotion, this.products)
         const gift = gifts[0]
         return {id: gift.id, name: gift.name, pieces: piecesRequired, total: 0}
      },
      askForCancelPromo(){
         const mssg = "¿Está seguro de cancelar la configuración de la promoción?\n"
         + "El avance de la configuración realizado hasta ahora será descartado." 
         this.confirmationDialog(this.backToListView, "Cancelar alta de promoción", mssg, "Confirmar")
      },
      backToListView(){
         this.currentView = this.LIST_VIEW
      },
      //wizard
      getWizardStepClass(stepNum){
         if(!this.currentStep){
            return null
         }
         let c = ""
         if(stepNum == this.currentStep.number){
            c = "current"
         }
         else {
            c = "disabled"
         }

         if(stepNum === 1){
            c += " first"
         }
         else if(stepNum === this.configSteps.length){
            c += " last"
         }
         return c
      }
   },
   computed: {
      ...mapState("cart", ["promotion_details"]),
      onListView(){
         return this.currentView === this.LIST_VIEW
      },
      onPurchaseView(){
         return this.currentView === this.PURCHASE_VIEW
      },
      onPurchaseQuantitySubview(){
         return (this.currentView === this.PURCHASE_VIEW && this.currentPurchaseSubview === this.PURCHASE_QUANTITY_SUBVIEW)
      },
      onPurchaseSetProductsSubview(){
         return (this.currentView === this.PURCHASE_VIEW && this.currentPurchaseSubview === this.PURCHASE_SET_PRODUCTS_SUBVIEW)
      },
      onPurchaseSetGiftsSubview(){
         return (this.currentView === this.PURCHASE_VIEW && this.currentPurchaseSubview === this.PURCHASE_SET_GIFTS_SUBVIEW)
      },
      onPurchaseConfigConfirmationSubview(){
         return (this.currentView === this.PURCHASE_VIEW && this.currentPurchaseSubview === this.PURCHASE_CONFIG_CONFIRMATION_SUBVIEW)
      },
      onPurchaseNonConfigConfirmationSubview(){
         return (this.currentView === this.PURCHASE_VIEW && this.currentPurchaseSubview === this.PURCHASE_NON_CONFIG_CONFIRMATION_SUBVIEW)
      },
      canShowQuantity(){
        return this.onPurchaseView && (this.onPurchaseSetProductsSubview || this.onPurchaseSetGiftsSubview 
        || this.onPurchaseConfigConfirmationSubview || this.onPurchaseNonConfigConfirmationSubview)
      },
      demoProducts(){
         return this.products;
      },
      canConfirm(){
         return (this.selectedProducts.length > 0 || this.selectedGifts.length > 0)
      },
      badgeClass(){
         let c = "";
         if(this.currentStock <= 3){
            c = "danger"
         }
         else if(this.currentStock <= 10){
            c = "warning"
         }
         else {
            c = "success"
         }
         return `badge-${c}`;
      },
      currentProductImgUrl(){
         return this.thumbnailUrl;
      },
      currentProductName(){
         return (this.currentPromotion) ? this.currentPromotion.name : "-";
      },
      currentStock(){
         return (this.currentPromotion) ? this.currentPromotion.applicable_quantity : 0; 
      },
      currentDescription(){
         return (this.currentPromotion) ? this.descripcionGeneralPromocion(this.currentPromotion) : "-";
      },
      currentLog() {
         return (this.currentPromotion) ? (this.currentPromotion.requirementsLog()) : "-";
      },
      currentPromoSetsProducts(){
         return (this.currentPromotion) ? this.currentPromotion.requiereConfiguracionProductos() : false;
      },
      currentPromoHasGifts(){
         return (this.currentPromotion) ? this.currentPromotion.ofreceRegalos() : false; 
      },
      currentPromoSetsGifts(){
         return (this.currentPromotion) ? this.currentPromotion.requiereConfiguracionRegalos() : false;
      },
      currentPromoIsConfigurable(){
         return (this.currentPromotion) ? this.currentPromotion.requiereConfiguracion() : false;
      },
      currentPromoOffersDiscount(){
         return (this.currentPromotion) ? this.currentPromotion.ofreceDescuento() : false;
      },
   }
}
</script>
